namespace RioERP.Web.Enums {
    export enum DiscountType {
        EqualDistribution = 1,
        NoDiscount = 2,
        FullDiscount = 3
    }
    Serenity.Decorators.registerEnumType(DiscountType, 'RioERP.Web.Enums.DiscountType');
}
